import { IComponentOptions } from "angular";
import { MachineConfigurationViewController } from "./controller";

export const vsComponentName = "machineConfigurationView";

export const machineConfigurationViewComponentOptions: IComponentOptions = {
  controller: MachineConfigurationViewController,
  controllerAs: "machineConfigurationViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    machineConfiguration: "<",
    editSref: "<",
    reportGroup: "<",
  },
  transclude: {
    configurationDetail: "configurationDetail",
  },
};
